module.exports = __webpack_public_path__ + "img/course-1.cdfd5523.png";